import $ from 'jquery';
import {gen, icon, isDefined, isMobile, isEmpty, scroll_to} from '../Helpers';
import Pop from './Pop';

export default class Menu {
    constructor(props) {
        this._data = {};
        this.header = $('#site-header');
        this.headerContainer = this.header.find('.container');
        this.site = $('.site');
        this.siteMenuToggle = $('#site-menu-toggle');
        this.siteLang = $('#site-lang');
        this.siteLogin = $('#site-login');
        this.siteMenu = $('#site-menu');
        this.is_open = false;

        this.init();
    }


    set is_open(x) {
        this._data.is_open = x;
        this.siteMenu.toggleClass('is_open', x);
        this.siteMenuToggle.toggleClass('on', x);
    }

    get is_open() {
        return this._data.is_open;
    }

    init() {
        foodbox['device'].mediaCheck({
            media  : '(max-width: 768px)', entry: () => {
                this.mobile_update();
            }, exit: () => {
                this.desktop_update();
            }
        });

        this.fixed_header();
        this.events();
    }

    fixed_header() {
        this.header.addClass('fixed');
        const headerHeight = this.header.outerHeight();
        //this.site.css('paddingTop', headerHeight);
       // $('#page').css('minHeight', `calc(100vh - ${headerHeight}px`);
    }

    mobile_update() {
        this.siteMenu.append(this.siteLang);
    }

    desktop_update() {
        this.headerContainer.append(this.siteLang);
    }


    events() {
        this.siteMenuToggle.click(() => {
            this.is_open = !this.is_open;
        });

        this.siteLogin.find('a').click(()=>this.showLoginPop());


            this.siteMenu.find('a').click((e) => {
                if($(e.target).attr('href')[0] !=='#'){
                    return
                }
                if(!foodbox.is_onepage) {
                    top.location = foodbox.home_url;
                    return;
                }

                e.preventDefault();
                const target = $($(e.target).attr('href'));
                if(!isEmpty(target)) {
                    scroll_to(target.offset().top, 350);
                    this.is_open = false
                }
            });


    }

    showLoginPop(){
        // Loader.show();
        $.ajax({
            url     :  foodbox.endpoints.get_login_pop,
            type    : 'POST',
            data:{lang:foodbox.lang.split('_')[0]},
            success : (res) => {
                if(res.success){
                    const content = res.data.content
                    const title = res.data.title
                    const pop = Pop.clean(title,content,function(){
                        const form = $('.pop_holder').find('form')
                       // wpcf7.initForm(form)
                        form.on('submit', (e)=>{
                            const data = {
                                'username': form.find('#user_login').val(),
                                'password': form.find('#user_pass').val()
                            }
                            Menu.login(data)
                            e.preventDefault();
                            return false
                        })

                        });
                    pop.show()
                }
            },
            error   : () => {   },
            complete: () => {
               // Loader.remove();
            }
        });

    }
    static login(data){
        console.log('todo>',data)
        Pop.close()
    }
}
